"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFeatureFlags = initFeatureFlags;
const featureFlagsHolderObject_1 = require("./featureFlagsHolderObject");
function initFeatureFlags(params) {
    if (params.schemas) {
        if (!featureFlagsHolderObject_1.featureFlagsHolderObject.schema) {
            featureFlagsHolderObject_1.featureFlagsHolderObject.schema = {};
        }
        for (const schema of params.schemas) {
            featureFlagsHolderObject_1.featureFlagsHolderObject.schema[schema.component] = schema;
        }
    }
    if (params.config) {
        featureFlagsHolderObject_1.featureFlagsHolderObject.config = params.config;
    }
    if (params.context != null) {
        featureFlagsHolderObject_1.featureFlagsHolderObject.context = params.context;
    }
    if (params.logRuleEvaluationError) {
        featureFlagsHolderObject_1.featureFlagsHolderObject.logRuleEvaluationError = params.logRuleEvaluationError;
    }
}
